export const isValidSortingKey = <T extends string>(
  value: string,
  enumObj: { [key: string]: T },
): value is T => {
  return Object.values(enumObj).includes(value as T);
};
